import * as React from "react";
import "src/styles/loading.css";

export default function LoadingSpinner(props: {className?: string, color?: string}) {
	return <div 
	className={"loading " + (props.className ? props.className : "")} 
	style={props.color ? {"--color-loading": props.color} as React.CSSProperties : {}}
	/>
}